import React from "react";
import { useResponsiveBelowMd } from "src/hooks";
import { FilterButton } from "./FilterButton";
import { FilterButtonBelowMd } from "./FilterButton.belowMd";
import { FilterButtonProps } from "./types";

export const FilterButtonResponsive = (props: FilterButtonProps) => {
  const isBelowMd = useResponsiveBelowMd();

  return isBelowMd ? (
    <FilterButtonBelowMd {...props} />
  ) : (
    <FilterButton {...props} />
  );
};
